module.exports = __webpack_public_path__ + "img/c413a50.jpg";